// extracted by mini-css-extract-plugin
module.exports = {"root":"Gallery_root__uqKQ7","indicator":"Gallery_indicator___3q9N","container":"Gallery_container__uP2NC","child":"Gallery_child__U1shY"};